var React = require('react');

function Other (props) {
    return React.createElement("svg",props,[React.createElement("path",{"data-name":"Oval 144","d":"M16 24a8 8 0 10-8-8 8 8 0 008 8z","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.2","key":0}),React.createElement("path",{"data-name":"Shape 1054","d":"M16 12v8","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.2","key":1}),React.createElement("path",{"data-name":"Shape 1055","d":"M12 16h8","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.2","key":2})]);
}

Other.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 32 32"};

module.exports = Other;

Other.default = Other;
